import React from "react";
import cx from "classnames";
//
import Button, { ButtonBasic } from "./Button";

export default function ScreenFoot({
  prevLabel,
  onBack,
  nextLabel,
  onNext,
  nextDisabled,
}) {
  return (
    <div
      className={cx("screen__foot", { "screen__foot--buttons": !!onBack })}
      tabIndex="-1"
    >
      <div className="screen__container">
        {!!onBack && <ButtonBasic title={prevLabel} onClick={onBack} />}
        {!!onNext && (
          <Button
            title={nextLabel}
            full={!onBack}
            onClick={onNext}
            disabled={nextDisabled}
          />
        )}
      </div>
    </div>
  );
}

ScreenFoot.defaultProps = {
  prevLabel: "Back",
  nextLabel: "Next",
};
